export default "__VITE_ASSET__DoWYRfos__"